import { createSlice } from "@reduxjs/toolkit";
// import networks from './config/networks.json'

const initial: any = {
  minSidebar: false,
  noneSidebar: false,
  isDark: false
};

// const coins: CoinTypes = {}
// for (let k in networks) {
//     coins[networks[k].coin] = { [k]: { address: '-', decimals: networks[k].decimals } }
// }

const initialState = {
  loading: false,
  inited: false,
  pending: {},
  walletBalance: 0,
  disconnect_able: false,
  address: null,
  selectedwallet: "",
  accounts: [],
  connected: false,
  balance: {
    confirmed: 0,
    unconfirmed: 0,
    total: 0,
  },
  ...initial,
};
//I should automatically create a flashcoins object.
//Current flashcoins is created statically

export default createSlice({
  name: "wallet",
  initialState,
  reducers: {
    update: (state: any, action) => {
      for (const k in action.payload) {
        if (state[k] === undefined) new Error("  undefined account item");
        state[k] = action.payload[k];
      }
    },
  },
});
